import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { MatIcon, MatIconRegistry } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sidenav-list',
  imports: [MatSidenavModule, MatIcon, MatListModule],
  standalone: true,
  templateUrl: './sidenav-list.component.html',
  styleUrl: './sidenav-list.component.scss'
})
export class SidenavListComponent implements OnInit {

  @Output() toggle = new EventEmitter<string>();
  isSideNavOpened = false;
  constructor(
    private matIconRegistry: MatIconRegistry, 
    private domSanitizer: DomSanitizer,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.matIconRegistry.addSvgIcon(
      'right_panel_close',
      this.domSanitizer.bypassSecurityTrustResourceUrl('./images/icons/sidebar-collapse.svg')
    );
  }
  toggleSidenav() {
    this.isSideNavOpened = !this.isSideNavOpened;
    this.toggle.emit(this.isSideNavOpened ? 'open' : 'close');
  }
  gotoHome() {
     this.router.navigate(['/']);
  }
}
